<svg [attr.height]="size" [attr.width]="size" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path
    d="M16.8116 8.90039C20.4116 9.21039 21.8816 11.0604 21.8816 15.1104V15.2404C21.8816 19.7104 20.0916 21.5004 15.6216 21.5004H9.11156C4.64156 21.5004 2.85156 19.7104 2.85156 15.2404V15.1104C2.85156 11.0904 4.30156 9.24039 7.84156 8.91039"
    [attr.stroke]="color" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M12.3711 2V14.88" [attr.stroke]="color" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M15.7215 12.6504L12.3715 16.0004L9.02148 12.6504" [attr.stroke]="color" stroke-width="1.5"
        stroke-linecap="round" stroke-linejoin="round"/>
</svg>
